import { useState, useCallback } from 'react';

// Ejecuta acciones que guardan en la base: controla el estado "guardando",
// muestra el error si algo falla y recarga los datos al terminar.
export function useAccion() {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const run = useCallback(async (accion, recargar) => {
    setSaving(true);
    setError('');
    let ok = true;
    try {
      await accion();
    } catch (e) {
      setError(e.message || String(e));
      ok = false;
    }
    if (recargar) {
      try { await recargar(); } catch (e) { setError(e.message || String(e)); }
    }
    setSaving(false);
    return ok;
  }, []);

  return { saving, error, setError, run };
}
